export default __webpack_public_path__ + "static/media/logo-auf-whitebg.5ef4327d.svg";